'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPhoneNumber = formatPhoneNumber;
// Reference table for trunk prefixes can be found there:
// https://www.howtocallabroad.com/codes.html.
var prefixUtil = exports.prefixUtil = {
  1: {
    country: 'US',
    trunkPrefix: null
  },
  32: {
    country: 'BE',
    trunkPrefix: 0
  },
  33: {
    country: 'FR',
    trunkPrefix: 0
  },
  34: {
    country: 'ES',
    trunkPrefix: null
  },
  39: {
    country: 'IT',
    trunkPrefix: null
  },
  43: {
    country: 'AT',
    trunkPrefix: 0
  },
  44: {
    country: 'GB',
    trunkPrefix: 0
  },
  46: {
    country: 'SE',
    trunkPrefix: 0
  },
  49: {
    country: 'DE',
    trunkPrefix: 0
  },
  41: {
    country: 'CH',
    trunkPrefix: 0
  },
  31: {
    country: 'NL',
    trunkPrefix: 0
  },
  351: {
    country: 'PT',
    trunkPrefix: null
  },
  48: {
    country: 'PL',
    trunkPrefix: null
  }
};

/**
 * Format the given phone number according to given country code.
 *
 * @param {string} countryCode Country internation call prefix (e.g. 49 for
 *                             Germany, 33 for france.
 * @return {string} the formatted number (e.g. +4817657003017).
 */
function formatPhoneNumber(countryCode, phoneNumber) {

  if (countryCode == null || phoneNumber == null) {
    throw new Error('Country code and or phoneNumber can\'t be null');
  }

  if (!Number.isInteger(Number(countryCode)) || !Number.isInteger(Number(phoneNumber))) {
    throw new Error('Country code and or phoneNumber is no valid number');
  } else {

    var code = Number(countryCode),
        supportedCodes = Object.keys(prefixUtil);

    // Do we support this country?
    if (supportedCodes.indexOf(countryCode) === -1) {
      throw new Error('Country code ' + countryCode + ' is not supported');
    } else {

      var trunkPrefix = prefixUtil[countryCode].trunkPrefix;

      // This country includes a fixed prefix that needs to be dropped, if
      // present, to format the international number.
      if (trunkPrefix !== null && phoneNumber.substr(0, 1) == trunkPrefix) {
        return '' + countryCode + phoneNumber.substr(1);
      } else {
        return '' + countryCode + phoneNumber;
      }
    }
  }
};